(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-carousel"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('editorial-carousel')) return;
  customElements.define('editorial-carousel', class extends HTMLElement {
    connectedCallback() {
      this.boot = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.boot);
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.events?.abort();
      this.resize?.disconnect();
      this.removeAttribute('data-ready');
    }
    init() {
      this.events?.abort();
      this.resize?.disconnect();
      this.events = new AbortController();
      const on = (el, type, fn, extra = {}) => el.addEventListener(type, fn, { ...extra, signal: this.events.signal });
      this.track = this.querySelector('.ec-track');
      this.slides = [...this.track.querySelectorAll('.ec-slide')];
      if (!this.slides.length) return;
      this.prev = this.querySelector('.ec-prev');
      this.next = this.querySelector('.ec-next');
      this.count = this.querySelector('.ec-count');
      this.status = this.querySelector('.ec-status');
      this.wrap = this.dataset.wrap === 'true';
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = Math.min(this.slides.length - 1, Math.max(0, (parseInt(this.dataset.start, 10) || 1) - 1));
      this.setAttribute('role', 'region');
      this.setAttribute('aria-roledescription', 'carousel');
      this.querySelector('.ec-controls').hidden = this.slides.length < 2;
      this.querySelector('.ec-nav').hidden = this.dataset.navigation === 'false';
      this.count.hidden = this.dataset.counter === 'false';
      this.slides.forEach((slide, i) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', `${this.position(i)}: ${slide.dataset.title}`);

      });
      this.setAttribute('data-ready', '');
      this.paint();
      this.go(this.index, false);
      on(this.prev, 'click', () => this.go(this.index - 1));
      on(this.next, 'click', () => this.go(this.index + 1));
      on(this.track, 'keydown', e => {
        if (e.target !== this.track || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(e.key in targets)) return;
        e.preventDefault();
        this.go(targets[e.key]);
      });
      on(this.track, 'scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => { this.index = this.nearest(); this.paint(); });
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (!this.drag) this.status.textContent = `${this.position(this.index)}: ${this.slides[this.index].dataset.title}`;
        }, 180);
      }, { passive: true });
      on(this.track, 'focusin', e => {
        const slide = e.target.closest('.ec-slide');
        if (slide) this.go(this.slides.indexOf(slide));
      });
      on(this.track, 'pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('a, button, input, textarea, select, [contenteditable]')) return;
        this.drag = { id: e.pointerId, x: e.clientX, left: this.track.scrollLeft, moved: false };
      });
      on(this.track, 'pointermove', e => {
        if (!this.drag || e.pointerId !== this.drag.id) return;
        const delta = e.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(delta) < 6) return;
        this.drag.moved = true;
        this.track.setPointerCapture(e.pointerId);
        this.track.classList.add('ec-dragging');
        e.preventDefault();
        this.track.scrollLeft = this.drag.left - delta;
      });
      const release = e => {
        if (!this.drag || e.pointerId !== this.drag.id) return;
        const moved = this.drag.moved;
        this.drag = null;
        this.track.classList.remove('ec-dragging');
        if (this.track.hasPointerCapture(e.pointerId)) this.track.releasePointerCapture(e.pointerId);
        if (moved) this.go(this.nearest());
      };
      on(window, 'pointerup', release);
      on(window, 'pointercancel', release);
      on(this.track, 'lostpointercapture', release);
      on(this, 'shopify:block:select', e => {
        const slide = e.target.closest('.ec-slide');
        if (slide && this.contains(slide)) this.go(this.slides.indexOf(slide), false);
      });
      this.resize = new ResizeObserver(() => {
        if (!this.drag && this.track.clientWidth) this.go(this.index, false);
      });
      this.resize.observe(this.track);
    }
    position(i) {
      return (this.dataset.position || '{index} of {total}').replaceAll('{index}', i + 1).replaceAll('{total}', this.slides.length);
    }
    nearest() {
      const box = this.track.getBoundingClientRect();
      const centre = box.left + this.track.clientLeft + this.track.clientWidth / 2;
      let best = 0, distance = Infinity;
      this.slides.forEach((slide, i) => {
        const r = slide.getBoundingClientRect();
        const d = Math.abs(r.left + r.width / 2 - centre);
        if (d < distance) { best = i; distance = d; }
      });
      return best;
    }
    go(i, animate = true) {
      const n = this.slides.length;
      i = this.wrap ? (i + n) % n : Math.max(0, Math.min(n - 1, i));
      const box = this.track.getBoundingClientRect();
      const r = this.slides[i].getBoundingClientRect();
      this.track.scrollBy({ left: r.left + r.width / 2 - (box.left + this.track.clientLeft + this.track.clientWidth / 2), behavior: animate && !this.reduced.matches ? 'smooth' : 'instant' });
      this.index = i;
      this.paint();
    }
    paint() {
      const n = this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.toggleAttribute('data-active', i === this.index);
        if (i === this.index) slide.setAttribute('aria-current', 'true');
        else slide.removeAttribute('aria-current');
      });
      [[this.prev, -1], [this.next, 1]].forEach(([button, step]) => {
        const target = this.index + step;
        const outside = target < 0 || target >= n;
        button.disabled = n < 2 || (!this.wrap && outside);
        const name = this.slides[(target + n) % n].dataset.title;
        button.querySelector('.ec-label').textContent = outside && !this.wrap ? (step < 0 ? this.dataset.first : this.dataset.last) : (this.dataset.see || 'See {title}').replaceAll('{title}', name);
      });
      this.count.textContent = this.position(this.index);
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-strength-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nic-strength-guide')) {
    customElements.define('nic-strength-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-choice]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        if (!this.tabs.length) return;
        this.querySelector('[data-selector]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', event => {
            event.preventDefault();
            this.select(index);
          }, options);
          tab.addEventListener('keydown', event => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next = index;
            if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key !== ' ' && event.key !== 'Enter') return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(tab => tab.dataset.choice === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.select(0, false);
      }
      select(index, reveal = true) {
        this.tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[position].hidden = !active;
        });
        if (reveal) {
          const scroll = this.querySelector('.nsg__scroll');
          const item = this.tabs[index].getBoundingClientRect();
          const viewport = scroll.getBoundingClientRect();
          if (item.left < viewport.left) scroll.scrollLeft += item.left - viewport.left - 4;
          else if (item.right > viewport.right) scroll.scrollLeft += item.right - viewport.right + 4;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
